export default class DataOption {
  constructor({
    type,
    label,
    labelStr,
    description,
    adapter,
    adapterParams,
    apiParams,
    baseColumns,
    chartOptions = [],
    defaultColumns,
    categoryDefs,
    hasCategories,
    filterCategories = ['callqueue', 'site', 'department', 'subscriber'],
    filterMultiples = true,
    defaultFormatType,
    formatType,
    hasColumns,
    liveData = false,
    socketEvents,
    socketSubscriptions,
    supportedCharts,
    supportedColumns,
    stat,
    unit,
  }) {
    this.type = type;
    this.label = label;
    this.labelStr = labelStr;
    this.description = description;
    this.adapter = adapter;
    this.baseColumns = baseColumns;
    this.chartOptions = chartOptions;
    this.defaultColumns = defaultColumns;
    this.adapterParams = adapterParams;
    this.apiParams = apiParams;
    this.stat = stat;
    this.categoryDefs = categoryDefs;
    this.hasCategories = hasCategories;
    this.filterCategories = filterCategories;
    this.filterMultiples = filterMultiples;
    this.defaultFormatType = defaultFormatType;
    this.formatType = formatType;
    this.hasColumns = hasColumns;
    this.liveData = liveData;
    this.socketEvents = socketEvents;
    this.socketSubscriptions = socketSubscriptions;
    this.supportedCharts = supportedCharts;
    this.supportedColumns = supportedColumns;
    this.unit = unit;
  }
}
